<div class="left-panel-container">
	<div class="logo-container">
		<img src="assets/images/amcn-mdm-logo.svg" alt="AMC" class="logo" />
	</div>

	<div class="pages" *ngIf="pages">
		<div
			class="page"
			[class.pointer]="!page.subPages?.length"
			*ngFor="let page of pages"
			(click)="onPageChange(page)"
		>
			<div *ngIf="!page.isHidden" class="page-name" [class.selected]="page.url === activePage?.url">
				<amc-iconify
					[color]="mdmColors.iconColor"
					size="l"
					[icon]="page.icon"
					[family]="page.iconFamily || 'mdi-light'"
					class="page-icon"
				></amc-iconify>
				{{ page.name }}
			</div>

			<div class="sub-pages" *ngIf="page.subPages?.length">
				<div
					*ngFor="let subPage of page.subPages"
					[class.selected]="subPage.id === activeSubPage?.id"
					[class.amcn-sub-page]="subPage.sourceId === 3"
					[class.avod-sub-page]="subPage.sourceId === 2"
					[class.svod-sub-page]="subPage.sourceId === 1"
					[class.sub-page]="subPage.sourceId !== 3 && subPage.sourceId !== 2 && subPage.sourceId !== 1"
				>
					<span class="arrow-container" *ngIf="subPage?.vendors?.length" (click)="openCloseSubPage(subPage)">
						<amc-iconify *ngIf="openedSubPageUrl === subPage.url" icon="chevron-up"></amc-iconify>
						<amc-iconify *ngIf="openedSubPageUrl !== subPage.url" icon="chevron-down"></amc-iconify>
					</span>

					<span
						class="sub-page-name"
						(click)="onPageChange(page, subPage, subPage?.vendors?.length ? subPage.vendors[0] : null)"
						>{{ subPage.name }}
					</span>

					<div class="vendors-container" *ngIf="openedSubPageUrl === subPage.url && subPage.vendors">
						<vendor
							*ngFor="let vendor of subPage.vendors"
							[isSelected]="subPage.id === activeSubPage?.id && vendor.url === activeVendor?.url"
							[image]="vendor.image"
							[name]="vendor.name"
							(clickVendor)="onPageChange(page, subPage, vendor)"
						></vendor>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
